import cn from 'classnames';
import type React from 'react';
import { memo, type ReactNode } from 'react';
import { Typography } from '@mui/material';
import { Card } from '@shared/ui';
import * as st from './styles.module.scss';

type PT = {
  openIndicatorNode: ReactNode;
  smallCardStatusNode: ReactNode;
  smallCardCostNode?: ReactNode;
  menuNode: ReactNode;
  title: string;
  authorName: string;
  onCardClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  className?: string;
};
export const SmallCard = memo(
  ({
    openIndicatorNode,
    smallCardStatusNode,
    smallCardCostNode,
    menuNode,
    title,
    authorName,
    onCardClick,
    className,
  }: PT) => {
    return (
      <Card className={cn(st.card, className)}>
        {openIndicatorNode}
        <div className={st.card__data}>
          <section className={st.card__top}>
            <div className={st.card__title} onClick={onCardClick}>
              <h3> {title}</h3>
              <Typography noWrap>{authorName}</Typography>
            </div>

            <div className={st.card__menu}>{menuNode}</div>
          </section>
          <div className={st.card__bottom} onClick={onCardClick}>
            {smallCardCostNode}
            {smallCardStatusNode}
          </div>
        </div>
      </Card>
    );
  }
);
